
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.414 20.002l8.001-8-8-8.002-1.414 1.414 6.586 6.587L4 18.587l1.414 1.415z"}}),_c('path',{attrs:{"d":"M11.996 20.002l8.001-8-8-8.002-1.414 1.414 6.586 6.587-6.587 6.586 1.414 1.415z"}})])
          )
        }
      }
    